import React from 'react';
import { CheckIcon, MinusIcon } from 'lucide-react';
import { Section, SectionTitle } from './Shared';
import { comparison, audience, PRODUCT_NAME } from '../data/pack';
export const Solution = () => <Section className="max-w-5xl" data-id="element-225" data-mp="10tpexjw0oj4m">
    <SectionTitle eyebrow="The Solution" lead={`The ${PRODUCT_NAME} brings your practice into one professional, organized and highly visual library.`} data-id="element-226" data-mp="10so4nhmts0ny">
      From Scattered Knowledge to a Complete Teaching System
    </SectionTitle>

    <div className="grid grid-cols-1 gap-5 md:grid-cols-2 md:gap-8" data-id="element-227" data-mp="vtut3ur3mjqf">
      <article className="rounded-2xl border border-brand-goldDark/20 bg-brand-surfaceLight/50 p-6 md:p-8" data-id="element-228" data-mp="vs05g8og0din">
        <h3 className="font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-muted md:text-xs" data-id="element-229" data-mp="hwobw4m0wt3b">
          Before the Bundle
        </h3>
        <ul className="mt-5 space-y-3" data-id="element-230" data-mp="2c9nvs9xfs9ge">
          {comparison.before.map(item => <li key={item} className="flex items-start gap-3" data-id="element-231" data-mp="2h6ecmzh2f92v">
              <MinusIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-muted" data-id="element-232" data-mp="70ieu4n0dz7l" />
              <span className="text-sm text-brand-textLight md:text-base" data-id="element-233" data-mp="6ydzmqjntds0">
                {item}
              </span>
            </li>)}
        </ul>
      </article>

      <article className="paper-panel rounded-2xl p-6 md:p-8" data-id="element-234" data-mp="gq1uz2jc7eyr">
        <h3 className="font-display text-[11px] font-semibold uppercase tracking-[0.2em] text-brand-burgundy md:text-xs" data-id="element-235" data-mp="br73zdb7uk3k">
          With the Bundle
        </h3>
        <ul className="mt-5 space-y-3" data-id="element-236" data-mp="3k93l164bt73l">
          {comparison.after.map(item => <li key={item} className="flex items-start gap-3" data-id="element-237" data-mp="3g7ru8x9puftt">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-238" data-mp="3u6htaig3ipkt" />
              <span className="text-sm font-medium text-brand-text md:text-base" data-id="element-239" data-mp="3p63rvj902dvr">
                {item}
              </span>
            </li>)}
        </ul>
      </article>
    </div>

    <p className="mx-auto mt-10 max-w-2xl text-center font-serif text-lg italic text-brand-burgundy md:text-xl" data-id="element-240" data-mp="14gnvm8r0hwyq">
      You keep your knowledge and personal teaching style. The Bundle gives you
      the structure to use them more effectively.
    </p>
  </Section>;
export const Audience = () => <Section className="max-w-4xl" data-id="element-241" data-mp="1lh0gf1w8jqmm">
    <div className="mb-10 text-center" data-id="element-242" data-mp="1litl4bnag0rz">
      <h2 className="font-serif text-3xl font-semibold leading-tight text-brand-burgundy md:text-4xl" data-id="element-243" data-mp="1qglezb7htwyt">
        Created for People Who Already Value Qigong
      </h2>
      <p className="mt-4 font-serif text-base italic text-brand-textLight/85 md:text-lg" data-id="element-244" data-mp="sufq84rhxkkn">
        The {PRODUCT_NAME} is ideal for:
      </p>
    </div>

    <ul className="mx-auto grid max-w-3xl grid-cols-1 gap-3 sm:grid-cols-2" data-id="element-245" data-mp="12raiw7138qr0">
      {audience.map(item => <li key={item} className="flex items-start gap-2.5 rounded-xl border border-brand-goldDark/15 bg-brand-surface/60 px-4 py-3" data-id="element-246" data-mp="17i0q7pt2r3oc">
          <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-brand-goldDark" data-id="element-247" data-mp="a0irdmuywqa0" />
          <span className="text-sm text-brand-text md:text-[15px]" data-id="element-248" data-mp="ezlqyrs6i4al">{item}</span>
        </li>)}
    </ul>

    <p className="mx-auto mt-8 max-w-2xl text-center text-sm text-brand-textLight md:text-base" data-id="element-249" data-mp="7fuizv9jffag">
      This is not a superficial introduction to Qigong. It is a professional
      support system for people who already practice, study or teach the
      discipline.
    </p>
  </Section>;